import * as React from 'react';

import * as styles from './NewbuildingCompilationFilterWrapper.css';

interface INewbuildingCompilationFilterWrapperProps {
  salesStart: React.ReactNode;
  salesLeader: React.ReactNode;
  discountMortgage?: React.ReactNode;
}

export const NewbuildingCompilationFilterWrapper: React.FC<INewbuildingCompilationFilterWrapperProps> = ({
  salesStart,
  salesLeader,
  discountMortgage,
}) => {
  return (
    <div className={styles['container']}>
      {salesStart}
      {salesLeader}
      {discountMortgage}
    </div>
  );
};
